<mat-toolbar class="sidemenu-toolbar">
    <i class="icon mdi mdi-api"></i>
    <span class="title">API</span>
</mat-toolbar>

<mat-accordion togglePosition="before" displayMode="flat">
    <mat-expansion-panel expanded="true" (opened)="panelSetter(false)">
      <mat-expansion-panel-header>
        <mat-panel-title class="flex-fill">
          List of API's
        </mat-panel-title>
       
      </mat-expansion-panel-header>
   <button  mat-stroked-button class="w-100" color="primary" *ngIf="[appPermissions.addApi,permissionsActions.edit] | builderPermissions" (click)="addApi(false)"><mat-icon>add</mat-icon>Add API</button>
        
   
      <mat-chip-listbox class="mat-mdc-chip-set-stacked" aria-label="Color selection" >
        <mat-chip-option *ngFor="let api of apis;let apiIndex = index" #chipApiOption (selectionChange)="selectedApi($event,api,false,chipApiOption)" >
          <div class="options">
            <div class="method">{{api.method}}</div>   
          <div class="api-name">{{api.apiName | truncate:40}}</div>
          <div class="api-url">{{api.apiURL | truncate:40}}</div>
          </div>
        </mat-chip-option>
      </mat-chip-listbox>
    </mat-expansion-panel>
    <mat-expansion-panel (opened)="panelSetter(true)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Authentication
        </mat-panel-title>
      </mat-expansion-panel-header>
     
          <button  mat-stroked-button color="primary" class="w-100" (click)="addApi(true)" *ngIf="[appPermissions.addApi,permissionsActions.edit] | builderPermissions"><mat-icon>add</mat-icon>Add Auth API</button>
      <mat-chip-listbox class="mat-mdc-chip-set-stacked" aria-label="Color selection" >
        <mat-chip-option  *ngFor="let api of authApis;let authIndex = index" #chipAuthApiOption (selectionChange)="selectedApi($event,api,true,chipAuthApiOption)">
          <div class="options">
            <div class="method">{{api.method}}</div>   
          <div class="api-name">{{api.apiName | truncate:40}}</div>
          <div class="api-url text-ellipsis">{{api.apiURL| truncate:40}}</div>
          </div>
        
        </mat-chip-option>
      </mat-chip-listbox>
    </mat-expansion-panel>
  </mat-accordion>
